import create from "zustand";
import { db } from "../../../../config/firebase.config";
import { collection, addDoc, getDoc, doc } from "firebase/firestore";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
import axios from "axios";

export const useStore = create((set, get) => ({
  livWishlist: [],
  singleProductSchema: (product) => {
    const newProduct = {
      id: product.id,
      handle: product.handle,
      title: product.title,
      price: product.variants.nodes[0]?.compareAtPriceV2?.amount,
      priceV2: product.variants.nodes[0]?.priceV2?.amount,
      image: product.variants.nodes[0].image.url,
      colour: product.variants.nodes[0].selectedOptions[0].value,
      allVariants: product.variants,
    };

    return newProduct;
  },
  addOrRemoveWishlist: (product) => {
    try {
      const arr = [];
      if (get()?.livWishlist !== null) {
        get()?.livWishlist?.filter((item) => {
          if (product.handle !== item?.handle) {
            arr.push(item);
          }
        });
        if (arr?.length < get().livWishlist?.length) {
          set({ livWishlist: arr });
        } else {
          set({ livWishlist: [...get()?.livWishlist, product] });
        }
        localStorage.setItem("livWishlist", JSON.stringify(get()?.livWishlist));
      } else {
        set({ livWishlist: [] });
        localStorage.setItem("livWishlist", JSON.stringify([]));
      }
    } catch (e) {
      console.log(e.message, "aye wrong in adding");
    }
  },
  addToDatabase: async (email, collectionProducts) => {
    try {
      const doc = await addDoc(collection(db, "wishlists"), {
        email,
        wishlist: get().livWishlist,
        createdAt: Date.now()
      });
      const ipAddressResponse = await axios.get(
        "https://api.ipify.org?format=json"
      );
      const ipAddress = ipAddressResponse?.data?.ip;
      // Use the IP address to get the user's location data
      let location = null;
      if(ipAddress) {
        location = await axios.get(
          `https://ipapi.co/${ipAddress}/json/`
        );
      }
      await axios.post("https://liv-app-integration.vercel.app/send-wishlist", {
        location,
        email,
        collectionProducts,
        image: get().livWishlist[0].image,
        url: `https://liv-cycling.vercel.app/wishlist/${doc.id}`
      });
      toast("Email sent!", { ...config, type: "success" });
    } catch (error) {
      if(error.message === "Network Error"){
        toast("Please switch to a different browser", { ...config, type: "error" });
      }
      else {
        toast(error.message, { ...config, type: "error" });
      }
    }
  },
  fetchFromDatabase: async (wishlistId) => {
    try {
      const response = await getDoc(doc(db, "wishlists", wishlistId));
      if(response?.data()?.wishlist){
        set({ livWishlist:response?.data()?.wishlist });
        localStorage.setItem("livWishlist", JSON.stringify(response?.data()?.wishlist));
      }
    } catch (error) {
      console.log("aye error from fetch database 1", error.message);
    }
  },
  fetchYourWishlist: () => {
    const array = localStorage.getItem("livWishlist");
    let wishlistArray = [];
    if (array) {
      wishlistArray = JSON.parse(array);
      set({ livWishlist: wishlistArray });
    }
  },
}));
